import { Movie } from '../types';

const WATCHLIST_KEY = 'cinestream_watchlist';

export const getWatchlist = (): Movie[] => {
  try {
    const saved = localStorage.getItem(WATCHLIST_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    console.error('Failed to parse watchlist:', e);
    return [];
  }
};

export const isInWatchlist = (id: string | number): boolean => {
  const list = getWatchlist();
  return list.some((item) => String(item.id) === String(id));
};

export const toggleWatchlist = (movie: Movie): boolean => {
  const list = getWatchlist();
  const existsIndex = list.findIndex((item) => String(item.id) === String(movie.id));
  let updated: Movie[] = [];
  let isAdded = false;

  if (existsIndex >= 0) {
    updated = list.filter((item) => String(item.id) !== String(movie.id));
    isAdded = false;
  } else {
    updated = [movie, ...list];
    isAdded = true;
  }

  try {
    localStorage.setItem(WATCHLIST_KEY, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('watchlistUpdated', { detail: { movie, isAdded, list: updated } }));
  } catch (e) {
    console.error('Failed to save watchlist:', e);
  }

  return isAdded;
};
